import { DataPipe } from './pipes/data.pipe';
// Angular
import { NgModule, LOCALE_ID, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClientXsrfModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule} from '@angular/platform-browser';
import {DecimalPipe, registerLocaleData} from '@angular/common';
import localePt from '@angular/common/locales/pt';
registerLocaleData(localePt, 'pt')

//Components
import { SafePipe } from './pipes/safe-pipe';
import { HttpXsrfInterceptor } from './interceptors/HttpXsrfInterceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import * as moment from 'moment'

//Components APP
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { SharedModule } from "./shared/shared.module";
import { AppComponent } from './app.component';
import { FormatterModule } from './resources-modules/formatter/formatter.module';
import { AuthGuard } from "./auth.guard";
import { AgmCoreModule } from '@agm/core';
import { MarkerManager,GoogleMapsAPIWrapper} from '@agm/core';

//Services
import { DataShareService } from './services/data-share.service';
import { ApiService } from './services/api.service';
import { UserStorageService } from './services/user-storage.service';
import { UserSessionService } from './services/user-session.service';
import {DataService} from './services/data-service'
import { UserService } from './services/user.service';
import { MapaService } from './services/mapa.service';
import { AndamentoService } from './services/andamento.service';
import { ProfileService } from './services/profile.service';
import { MonitorService } from './services/monitor.service';
import { TransformaObjetoEmListaPipe } from './pipes/transformaObjetoEmLista.pipe';
import { MapaResolver } from './services/mapa-resolver.service';
import { AgenteService } from './services/agente.service';
import { UnidadesPorUsuarioService } from './services/unidades-por-usuario.service';
import { AlertaPanico } from './services/alertaPanico.service';
import{OrdenacaoPorCheckedService} from'./services/ordena-objetos-por-checked-true.service';
import { DespachoService } from './services/despacho.service';
import { DespachoNoLocalService } from './services/despacho-no-local.service';
import { DespachoAtenderService } from './services/despachoAtender.service';
import { DespachoFecharService } from './services/despachoFechar.service';
import { DespachoDevolverService } from './services/despachoDevolver.service';
import { DespachoNaoAtenderService } from './services/despachoNaoAtender.service';
import { TroService } from './services/tro.service';


@NgModule({
    declarations: [
        AppComponent,
        routingComponents,
        SafePipe,
        DataPipe,
        TransformaObjetoEmListaPipe,
    ],
    imports: [
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        NgbModule.forRoot(),
        FormatterModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'PHPSESSID',
            headerName: 'Set-Cookie'
        }),
        AgmCoreModule.forRoot({
            //clientId: 'Mapa',
            //clientId: 'mapa2',
            clientId: 'gme-guardamunicipaldo',
            libraries: ['places']
         }),
    ],
    providers: [ApiService,
        DataShareService,UserService ,
        UserStorageService,
        AuthGuard,
        UserSessionService,
        DataService,
        MarkerManager,
        GoogleMapsAPIWrapper,
        MapaService,
        MapaResolver,
        AgenteService,
        // ValidaResetDesenhaService,
        AndamentoService,
        MonitorService,
        DecimalPipe,
        DataPipe,
        TransformaObjetoEmListaPipe,
        UnidadesPorUsuarioService,
        // AndamentosDaSolicitacao,
        OrdenacaoPorCheckedService,
        AlertaPanico,
        DespachoService,
        DespachoNoLocalService,
        DespachoAtenderService,
        DespachoNaoAtenderService,
        DespachoFecharService,
        DespachoDevolverService,
        TroService,
        { provide: HTTP_INTERCEPTORS, useClass: HttpXsrfInterceptor, multi: true },
        { provide: APP_INITIALIZER, useFactory: (config: ApiService) => () => config.load(), deps : [ApiService], multi: true },
        {provide: LOCALE_ID, useValue: 'pt'}
    ],
    bootstrap: [AppComponent],
    schemas:  [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts